"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterForm = exports.PossibleUserTypeEnum = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var formik_1 = require("formik");
var react_google_recaptcha_1 = require("react-google-recaptcha");
var dhsInstallerHelpers_1 = require("../../DhsInstaller/helpers/dhsInstallerHelpers");
var FormikConfig_1 = require("Views/Partials/Components/FormikFields/FormikConfig");
var RadioButtonGroup_1 = require("Views/Partials/Components/RadioButtonGroup");
var NewsletterFormConfig_1 = require("../NewsletterFormConfig");
var PossibleUserTypeEnum;
(function (PossibleUserTypeEnum) {
    PossibleUserTypeEnum[PossibleUserTypeEnum["Business"] = 0] = "Business";
    PossibleUserTypeEnum[PossibleUserTypeEnum["Personal"] = 1] = "Personal";
})(PossibleUserTypeEnum = exports.PossibleUserTypeEnum || (exports.PossibleUserTypeEnum = {}));
var NewsletterForm = function (props) {
    var _a = React.useState(null), formState = _a[0], setFormState = _a[1];
    var recaptchaRef = React.createRef();
    var RecaptchaComponent = react_google_recaptcha_1.default;
    var gtmData = (function () {
        var items = props.items, control = props.control;
        var titleText = items.specificFields.titleText;
        return {
            control: control,
            label: items.submitLabel,
            title: titleText,
        };
    })();
    var apiUrl = props.apiUrl, additionalFormData = props.additionalFormData, reCaptchaSiteKey = props.reCaptchaSiteKey, _b = props.items, specificFields = _b.specificFields, userTypes = _b.userTypes, renderMessage = props.renderMessage, renderSpinner = props.renderSpinner, pageId = props.pageId, bypassRecaptchaKey = props.bypassRecaptchaKey;
    var businessValidationSchema = NewsletterFormConfig_1.getBusinessValidationSchema(props);
    var personalValidationSchema = NewsletterFormConfig_1.getPersonalValidationSchema(props);
    // Setup Form settings
    var userTypeGroupLabel = specificFields && specificFields.userTypeLabel;
    var userTypesRadioGroup = React.useMemo(function () { return userTypes.map(function (_a) {
        var value = _a.key, label = _a.value;
        return ({ label: label, value: value });
    }); }, [userTypes]);
    var userType = formState && formState.userType;
    var isBusinessFormType = userType === userTypes[PossibleUserTypeEnum.Business].key;
    var validationSchema = isBusinessFormType ? businessValidationSchema : personalValidationSchema;
    var formConfig = isBusinessFormType ? NewsletterFormConfig_1.businessTypeFormConfig : NewsletterFormConfig_1.personalTypeFormConfig;
    var recaptchaBypass = FormikConfig_1.recaptchaKeyGuard(bypassRecaptchaKey);
    var initialFormState = isBusinessFormType ? NewsletterFormConfig_1.businessInitialFormState : NewsletterFormConfig_1.personalInitialFormState;
    // Update Form initial values
    initialFormState = dhsInstallerHelpers_1.updateInitialFormValues(props, initialFormState);
    return (React.createElement("div", { className: "newsletter-form-main" },
        React.createElement("div", { className: "radio" },
            React.createElement(RadioButtonGroup_1.RadioButtonGroup, { name: "userType", customGroupClassName: "newsletter-form__user-type-group", caption: userTypeGroupLabel, radioGroupList: userTypesRadioGroup, onClick: function (event) {
                    return setFormState(function (prevState) { return (tslib_1.__assign(tslib_1.__assign({}, prevState), { userType: event.currentTarget.value })); });
                } })),
        userType && (React.createElement(formik_1.Formik, { initialValues: initialFormState, validationSchema: validationSchema, enableReinitialize: true, validateOnBlur: false, validateOnMount: true, onSubmit: function (values) {
                recaptchaBypass
                    ? FormikConfig_1.submitForm(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, '', pageId)
                    : dhsInstallerHelpers_1.performReCaptchaCheck(recaptchaRef, renderMessage, specificFields);
                setFormState(function (prevState) { return (tslib_1.__assign(tslib_1.__assign({}, prevState), values)); });
            } }, function (_a) {
            var values = _a.values, errors = _a.errors, touched = _a.touched, isSubmitting = _a.isSubmitting, isValidating = _a.isValidating;
            dhsInstallerHelpers_1.handleGtmValidationError(isValidating, isSubmitting, gtmData, errors, values);
            return (React.createElement(formik_1.Form, null, FormikConfig_1.renderFormItems(props, errors, touched, values, gtmData, formConfig)));
        })),
        !recaptchaBypass && ReactDOM.createPortal(React.createElement(RecaptchaComponent, { className: "newsletter-recaptcha recaptcha-mounted", ref: recaptchaRef, size: "invisible", sitekey: reCaptchaSiteKey, onChange: function (recaptchaToken) {
                return FormikConfig_1.submitForm(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, recaptchaToken, pageId);
            }, onErrored: function () { return dhsInstallerHelpers_1.handleError(gtmData, renderMessage, specificFields); } }), document.body)));
};
exports.NewsletterForm = NewsletterForm;
